import { ResolvedPos } from 'prosemirror-model'

export function pointsAtCell($pos: ResolvedPos) {
  return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter
}
